:global .rich-text {
  width: 100%;
}

.wrap trix-toolbar {
  button {
    display: none;
  }

  button.trix-button--icon-link {
    display: inline-block;
  }
}

.wrap {
  :global(.trix-dialog__link-fields) {
    position: fixed;
    left: calc(50% + 14px);
    top: 10px;
    z-index: 9;
    width: calc(49% - 100px);

    & > input {
      margin-bottom: 10px;
      width: 100%;
    }
  }

  :global(main.dragging) & {
    visibility: hidden;
  }

  :global(.trix-button--icon-link.trix-active) {
    display: block;
    position: fixed;
    left: calc(50% + 14px);
    top: 10px;
    z-index: 9;
    width: 100px;
    cursor: pointer;

    padding: 1em !important;
    word-wrap: break-word;
    cursor: pointer;
    font-size: 1em;
    font-weight: 500;
    outline: none;
    background-color: #eee;
    border: none;
    border-radius: .25em;
  }
}

.wrap trix-editor {
  width: 100%;
  border: none;
  border-radius: 0;
  padding: 3px 4px 3px;
  min-height: 0;
  line-height: 1.3;
  outline: none;

  &:not(.active):hover {
    background: #e8e8e8;
    cursor: pointer;
  }

  a {
    color: blue;
  }
}

.html {
  font-family: 'Courier New', Courier, monospace;  
}